import {Utils} from '@astek/utils';
import {JsonConfigInterface} from './json-config-interface';
import {PressureGraphConfig, PressureGraphConfigJson} from './pressure-graph-config';
import {MeanPressureComputationConfig, MeanPressureConfigJson} from './mean-pressure-computation-config';
import {MeanPressureGraphConfig, MeanPressureGraphConfigJson} from './mean-pressure-graph-config';

export type MeasurementsConfigJson = {
  meanPressureGraph: MeanPressureGraphConfigJson;
  rawPressureGraph: PressureGraphConfigJson;
  meanPressureComputation: MeanPressureConfigJson;
};

export class MeasurementsConfig implements JsonConfigInterface<MeasurementsConfigJson> {

  public readonly meanPressureGraph: MeanPressureGraphConfig = new MeanPressureGraphConfig();
  public readonly rawPressureGraph: PressureGraphConfig = new PressureGraphConfig();
  public readonly meanPressureComputation: MeanPressureComputationConfig = new MeanPressureComputationConfig();

  constructor(json?: MeasurementsConfigJson) {
    if (!Utils.isNullOrUndefined(json)) {
      this.deserializeJson(json);
    }
  }

  public deserializeJson(json: MeasurementsConfigJson): void {
    this.meanPressureGraph.deserializeJson(json.meanPressureGraph);
    this.rawPressureGraph.deserializeJson(json.rawPressureGraph);
    this.meanPressureComputation.deserializeJson(json.meanPressureComputation);
  }
}
